var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 35,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.45 5.472l2.494 4.987c.34.694 1.247 1.36 2.012 1.488l4.52.75c2.89.482 3.57 2.579 1.487 4.647l-3.514 3.514c-.595.595-.92 1.742-.736 2.564l1.005 4.349c.794 3.442-1.034 4.774-4.08 2.975l-4.235-2.508c-.765-.453-2.026-.453-2.805 0l-4.236 2.508c-3.032 1.799-4.874.453-4.08-2.975l1.006-4.35c.184-.821-.142-1.968-.737-2.563l-3.513-3.514c-2.069-2.068-1.403-4.165 1.487-4.647l4.52-.75c.75-.128 1.657-.794 1.997-1.488l2.493-4.987c1.36-2.705 3.57-2.705 4.916 0z",
    stroke: "#DD0510",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.d593bf82cce1ea4ee77186f5ed173667.svg";
export { ForwardRef as ReactComponent };